import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllGlobalPermissions } from 'auth/store/globalPermissions/actions';
import MainTitle from 'base/components/MainTitle';
import Header from 'base/components/Header';
import { getAllRoles } from 'auth/store/roles/selectors';
import { fetchAllRoles, updateRole } from 'auth/store/roles/actions';
import {
  getAllGlobalPermissions,
} from 'auth/store/globalPermissions/selectors';
import { DataTable, LargeLabelCell } from 'base/components/table';
import { Checkbox } from 'base/components/forms';
import theme from '../../theme';


const GlobalPermissions = () => {
  const roles = useSelector(getAllRoles);
  const permissions = useSelector(getAllGlobalPermissions);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAllRoles());
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchAllGlobalPermissions());
  }, [dispatch]);

  const columns = [
    {
      Header: 'Role',
      id: 'name',
      accessor: 'name',
      Cell: LargeLabelCell('name'),
      showOnMobile: true,
    },
    ...(permissions.map((permission) => ({
      Header: permission.name,
      id: permission.id,
      Cell: ({ original }) => {
        const isChecked = original.permissions && original.permissions.includes(permission.id);
        return (
          <Checkbox
            background={theme.colors.light}
            checked={isChecked}
            onChange={(event) => {
              const isGranting = event.target.checked;
              const updatedRole = {
                ...original,
                permissions: isGranting
                  ? [...original.permissions, permission.id]
                  : [...original.permissions.filter((id) => id !== permission.id)]
                ,
              };
              dispatch(updateRole(updatedRole));
            }}
          />
        );
      },
    }))),
  ];


  return (
    <>
      <Header>
        <MainTitle>
        Global permissions
        </MainTitle>
      </Header>
      <DataTable
        data={roles}
        columns={columns}
      />
    </>
  );
};

export default GlobalPermissions;
